import {Injectable} from '@nestjs/common';
import {AgentService} from '../agent/agent.service';
import {StreamCallback} from '../../infrastructure/llm/ai-client';

/**
 * 聊天业务逻辑服务
 */
@Injectable()
export class ChatService {
  constructor(private readonly agentService: AgentService) {}

  /**
   * 编排并执行聊天任务流
   * @param settings AI 配置
   * @param prompt 提示词
   * @param onChunk 流式回调
   */
  async streamChatCompletion(
    settings: any,
    prompt: string,
    onChunk: StreamCallback,
  ): Promise<string> {
    return await this.agentService.runAgentTask(settings, prompt, onChunk);
  }
}
